import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

let lastTrackedPagePath = null;

function GoogleAnalyticsTracker() {
  const location = useLocation();
  const isInitialRender = useRef(true);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;

    // The Google tag in index.html sends the initial page view on load.
    if (isInitialRender.current) {
      isInitialRender.current = false;
      lastTrackedPagePath = pagePath;
      return;
    }

    if (
      pagePath === lastTrackedPagePath ||
      typeof window.gtag !== "function" ||
      !window.googleAnalyticsMeasurementId
    ) {
      return;
    }

    lastTrackedPagePath = pagePath;
    try {
      window.gtag("config", window.googleAnalyticsMeasurementId, {
        page_path: pagePath,
        anonymize_ip: true,
      });
    } catch {
      // Route changes must continue normally when analytics is blocked.
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export default GoogleAnalyticsTracker;
